import { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert } from 'antd';
import { UserOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const { Title } = Typography;

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, error, clearError } = useAuth();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { email: string; password: string; totp_code?: string }) => {
    clearError();
    setLoading(true);
    try {
      await login(values);
      navigate('/');
    } catch (err) {
      // Error is already handled in the store
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <Card style={{ width: 400, boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} style={{ marginBottom: 8 }}>
            🎵 Kompozitor Admin
          </Title>
          <Typography.Text type="secondary">
            Увійдіть до панелі адміністратора
          </Typography.Text>
        </div>

        {error && (
          <Alert
            message={error}
            type="error"
            closable
            onClose={clearError}
            style={{ marginBottom: 16 }}
          />
        )}

        <Form name="login" onFinish={onFinish} size="large">
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Введіть email' },
              { type: 'email', message: 'Невірний формат email' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Email"
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Введіть пароль' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Пароль"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item name="totp_code">
            <Input
              prefix={<SafetyCertificateOutlined />}
              placeholder="2FA code (if enabled)"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Увійти
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
